
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clinical-trials",
      function () {
        return require("private-next-pages/clinical-trials/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clinical-trials"])
      });
    }
  